import React from 'react'
import SbEditable from 'storyblok-react'
import Helmet from 'react-helmet'

import TextRenderer from './../TextRenderer'
import ButtonPrimary from './../ButtonPrimary'

import styles from './styles.module.scss'

const Member = (props) => {
    const seoTitle = `Equalize Health - ${props.blok.name} - Medical technology for everyone`
    const seoDescription = 'Healthcare around the world is unacceptably unequal. Equalize health is a not-for-profit medical technology company on a mission to change that.'
    return (
        <>
            <Helmet
                title={seoTitle}
                meta={[
                    { 
                        name: 'title', 
                        content: seoTitle
                    },
                    { 
                        name: 'description', 
                        content: seoDescription
                    },
                    { 
                        name: 'twitter:title', 
                        content: seoTitle
                    },
                    { 
                        name: 'twitter:description', 
                        content: seoDescription
                    },
                    { 
                        name: 'og:title', 
                        content: seoTitle
                    },
                    { 
                        name: 'og:description', 
                        content: seoDescription
                    },
                    { 
                        name: 'image', 
                        content: `https://a.storyblok.com/f/95584/1200x630/e048a53f5c/seo-image.jpg`
                    },
                    { 
                        name: 'twitter:image', 
                        content: `https://a.storyblok.com/f/95584/1200x630/e048a53f5c/seo-image.jpg`
                    },
                    { 
                        name: 'og:image', 
                        content: `https://a.storyblok.com/f/95584/1200x630/e048a53f5c/seo-image.jpg`
                    },
                    { 
                        name: 'image', 
                        property: 'og:image',
                        content: `https://a.storyblok.com/f/95584/1200x630/e048a53f5c/seo-image.jpg`
                    },
                    { 
                        name: 'twitter:card', 
                        content: `summary_large_image`
                    }
                ]}
            />
            <SbEditable content={props.blok}>
                <section className={styles['member']}>
                    <div className='container'>
                        <div className={styles['member__header']}>
                            <div className={styles['member__author-wrapper']}>
                                {props.blok.image.filename && <img src={props.blok.image.filename} className={styles['member__author-image']} alt={props.blok.image.alt} />}
                                <div className={styles['member__author-info']}>
                                    <h1 className={`heading-4 ${styles['member__author-name']}`}><b>{props.blok.name}</b></h1>
                                    <span className={`body ${styles['member__author-title']}`}>{props.blok.title}</span>
                                </div>
                            </div>
                            <div className={styles['member__desktop-action']}>
                                <ButtonPrimary link={{ linkType: 'internal', cached_url: 'our-team' }} label='View all members' />
                            </div>
                        </div>
                        <TextRenderer text={props.blok.description} />
                        <div className={styles['member__mobile-action']}>
                            <ButtonPrimary link={{ linkType: 'internal', cached_url: 'our-team' }} label='View all members' />
                        </div>
                    </div>
                </section>
            </SbEditable>
        </>
    )
}

export default Member
